export default __webpack_public_path__ + "static/media/bg.15b2e2eb.png";